import { render, staticRenderFns } from "./role-setting.vue?vue&type=template&id=a29872a8&scoped=true"
import script from "./role-setting.vue?vue&type=script&lang=js"
export * from "./role-setting.vue?vue&type=script&lang=js"
import style0 from "./role-setting.vue?vue&type=style&index=0&id=a29872a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29872a8",
  null
  
)

export default component.exports